module.exports = __webpack_public_path__ + "static/media/json.e1ee4f81.png";